<template>
    <div class="flex-column" style="background-color:#fff;" v-if="checkin.template == 0">
        <div class="flex-row-between padding-20-30">
            <div class="flex-row">
                <span class="text-30-black">签到动态</span>
                <div @click="changeType('all')" class="choose-btn" :class="{active: curTag == 'all'}">全部</div>
                <div @click="changeType('today')" class="choose-btn" :class="{active: curTag == 'today'}">今天</div>
                <div @click="changeType('date')" class="choose-btn" :class="{active: curTag == 'date'}">{{currentDateText ? currentDateText : '选择日期'}}</div>
            </div>
            <!-- 可以发布任务的签到，可以选择 -->
            <!-- <div class="flex-row" @click="showActionSheet">
                <span class="text-30-blue">全部签到</span>
                <img class="icon-30" src="@/assets/icon/ic_show_work.png" />
            </div> -->
        </div>
        <div class="divider"></div>
        <!-- 签到记录 -->
        <div class="list" v-if="records.length > 0">
            <div class="item" v-for="item in records" :key="item.pt_id">
                <!-- 头像 -->
                <avatar :adv_avatar="item.adv_avatar" :head_url="item.head_url" :size="36"></avatar>
                <!-- 右侧 -->
                <div class="flex-column left-10" style="flex:1;">
                    <!-- 头部 -->
                    <div class="flex-row-between" :style="{height: 36 * 3 / 75 + 'rem'}">
                        <div class="flex-column" style="justify-content:center;">
                            <div class="flex-row">
                                <div class="stu-no" v-if="item.stu_no">{{item.stu_no}}</div>
                                <div :style="{color: item.name_color ? item.name_color : ''}" class="text-30-black">{{item.name}}</div>
                                <img src="@/assets/icon/ic_top.png" v-if="item.top" class="top-img" />
                            </div>
                            <div class="flex-row top-10">
                                <span class="text-22-99">{{item.date}}</span>
                                <img src="@/assets/icon/daiqian.png" v-if="item.is_agent == 1" class="icon-buqian" />
                                <img src="@/assets/icon/buqian.png" v-if="item.makeup == 1" class="icon-buqian" />
                            </div>
                        </div>
                        <div>
                            <!-- <img class="icon-edit" src="@/assets/icon/ic_edit.png" />
                            <span class="text-22-99">编辑</span> -->
                        </div>
                    </div>

                    <!-- 内容 -->
                    <div class="flex-column">
                        <div v-if="item.is_audit == 0">
                            <div v-for="(fill_param, fillParamIndex) in item.fill_params" :key="fillParamIndex">
                                <div class="checkin-text" v-if="fill_param.key > 8 && fill_param.key != 100">{{fill_param.name}}：{{fill_param.val}}</div>
                            </div>
                        </div>

                        <div class="checkin-text" v-if="item.is_audit == 1">签到内容正在审核中，审核通过后会自动展示</div>
                        <div class="checkin-text" v-if="item.is_audit == 2">签到内容违规，已被隐藏</div>
                        
                        <div class="flex-column" v-for="( fill_param, fillParamIndex) in item.fill_params" :key="fillParamIndex">
                            <!-- 文字 -->
                            <div class="checkin-text" v-if="fill_param.key == 1 && fill_param.val && item.is_audit==0" :style="{color: item.text_color}">{{fill_param.val}}</div>
                            <!-- 图片 -->
                            <comment-pic v-if="fill_param.key == 2 && fill_param.val && fill_param.val.length > 0" :urls="fill_param.val"></comment-pic>
                            <comment-pic v-if="fill_param.key == 100 && fill_param.val && fill_param.val.length > 0" :urls="fill_param.val"></comment-pic>
                            <!-- 视频 需要重写 -->
                            <video-box v-if="fill_param.key == 3 && fill_param.val && fill_param.val.length > 0" :thumb="fill_param.val[0].thumb" :url="fill_param.val[0].url"></video-box>
                            <!-- 音频 -->
                            <div class="audio-list" v-if="fill_param.key == 4 && fill_param.val && fill_param.val.length > 0">
                                <div @click="playAudio(audio.url,item.pt_id)" class="audio-box" v-for="(audio,audioIndex) in fill_param.val" :key="audioIndex">
                                    <img class="audio-img" src="@/assets/icon/audio.png" />
                                    <span class="audio-duration">{{audio.len}}″</span>
                                </div>
                            </div>
                            <!-- 文件 -->
                            <open-document class="top-20" v-if="fill_param.key == 5 && fill_param.val.length > 0" :file_name="fill_param.val[0].name" :file_url="fill_param.val[0].url"></open-document>
                            <!-- 地址 -->
                            <div class="address-box top-20" v-if="fill_param.key == 6 && fill_param.val">
                                <img class="address-icon" src="@/assets/icon/address_add.png"/>
                                <span class="address-text">{{fill_param.val}}</span>
                            </div>
                            <!-- 微信步数 -->
                            <div v-if="fill_param.key == 7 && fill_param.val != -1">
                                <span class="step-box" v-if="fill_param.val == -2">
                                    <span class="step-text">该设备不支持计步</span>
                                </span>
                                <div class="step-box" v-else>
                                    <div class="step-box-content">
                                        <img class="step-icon" src="@/assets/icon/ic_run.png" />
                                        <span class="step-text"> 打卡步数 {{fill_param.val}}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 微信文章 -->
                            <article-box v-if="fill_param.key == 8 && fill_param.val" :mp_icon="fill_param.val.mp_icon" :mp_url="fill_param.val.mp_url" :mp_title="fill_param.val.mp_title"></article-box>
                        </div>
                        <!-- 修正内容 -->
                        <div class="flex-column" v-if="item.fix.date">
                            <span class="text-28-33">------订正如下------</span>
                            <span class="checkin-time">{{item.fix.date}}</span>
                            <div v-for="(fill_param,fillParamIndex) in item.fix.fill_params" :key="fillParamIndex">
                                <!-- 文字 -->
                                <div :style="{color: fill_param.text_color}" class="checkin-text" v-if="fill_param.key > 8 && fill_param.key != 100">{{fill_param.name}}：{{fill_param.val}}</div>
                                <div :style="{color: fill_param.text_color}" class="checkin-text" v-if="fill_param.key == 1 && fill_param.val">{{fill_param.val}}</div>
                                <!-- 图片 -->
                                <comment-pic v-if="fill_param.key==2 && fill_param.val.length > 0" :urls="fill_param.val"></comment-pic>
                                <comment-pic v-if="fill_param.key == 100 && fill_param.val && fill_param.val.length > 0" :urls="fill_param.val"></comment-pic>
                                <!-- 视频 -->
                                <video-box  v-if="fill_param.key == 3 && fill_param.val && fill_param.val.length > 0" :thumb="fill_param.val[0].thumb" :url="fill_param.val[0].url"></video-box>
                                <!-- 音频 -->
                                <div class="audio-list" v-if="fill_param.key == 4 && fill_param.val && fill_param.val.length > 0">
                                    <div @click="playAudio(audio.url,item.pt_id)" class="audio-box" v-for="(audio,audioIndex) in fill_param.val" :key="audioIndex">
                                        <img class="audio-img" src="@/assets/icon/audio.png" />
                                        <span class="audio-duration">{{audio.len}}″</span>
                                    </div>
                                </div>
                                <!-- 文件 -->
                                <open-document class="top-20" v-if="fill_param.key == 5 && fill_param.val.length > 0" :file_name="fill_param.val[0].name" :file_url="fill_param.val[0].url"></open-document>
                                <!-- 地址 -->
                                <div class="address-box top-20" v-if="fill_param.key == 6 && fill_param.val">
                                    <img class="address-icon" src="@/assets/icon/address_add.png"/>
                                    <span class="address-text">{{fill_param.val}}</span>
                                </div>
                                <!-- 微信步数 -->
                                <div v-if="fill_param.key == 7 && fill_param.val != -1">
                                    <span class="step-box" v-if="fill_param.val == -2">
                                        <span class="step-text">该设备不支持计步</span>
                                    </span>
                                    <div class="step-box" v-else>
                                        <div class="step-box-content">
                                            <img class="step-icon" src="@/assets/icon/ic_run.png" />
                                            <span class="step-text"> 打卡步数 {{fill_param.val}}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- 微信文章 -->
                                <article-box v-if="fill_param.key == 8 && fill_param.val" :mp_icon="fill_param.val.mp_icon" :mp_url="fill_param.val.mp_url" :mp_title="fill_param.val.mp_title"></article-box>
                            </div>
                        </div>
                        
                    </div>
                    <!-- 音频播放器，通用 -->
                        <audio class="audio" v-if="showAudioPlayer && pt_id==item.pt_id" controls :src="audioSrc" autoplay />
                    <!-- 底部 -->
                    <div class="flex-row-between top-20" style="flex:1;" v-if="checkin.template != 1">
                        <div class="flex-row">
                            <div @click="showDialog" class="flex-row right-10" v-if="checkin.no_com == 0">
                                <img class="icon-40" src="https://cdn-xcxcustom.weiyoubot.cn/20210625/a05aa09455c8887a49485be3040116ac.png" />
                                <span class="text-28-99">评论</span>
                            </div>
                            <div @click="showDialog" class="flex-row right-10" v-if="checkin.no_forward==0 ||(checkin.no_forward==1 && checkin.is_owner)">
                                <img class="icon-40" src="https://cdn-xcxcustom.weiyoubot.cn/20210624/d8b2f7df6d0885d2f0c9de75edb0becc.png" />
                                <span class="text-28-99">分享</span>
                            </div>
                            <div @click="showDialog" class="flex-row right-10">
                                <img class="icon-40" src="https://cdn-xcxcustom.weiyoubot.cn/20210624/b2392fecc135826a09c34adf5b6f88bd.png" />
                                <span class="text-28-99">详情</span>
                            </div>
                            <div @click="showDialog" class="flex-row right-10" v-if="(checkin.is_owner==1||checkin.is_admin==1)">
                                <img class="icon-40" src="https://cdn-xcxcustom.weiyoubot.cn/20210624/85588d3cdf3868a09f0ae8947c199d29.png" />
                                <span class="text-28-99" style="color:#fea356">点评</span>
                            </div>
                        </div>
                        <div @click="showDialog" class="flex-row">
                            <img class="like-img" :src="item.like == 1 ? 'https://cdn-xcxcustom.weiyoubot.cn/20210624/c16e92e3db9fcafd40c52282e6803d69.png' : 'https://cdn-xcxcustom.weiyoubot.cn/20210624/70caf25d8ec30da772cbbf1055d2a592.png'"/>
                            <span class="like-text">{{item.like_count}}</span>
                        </div>
                    </div>
                    <!-- 点评详情 -->
                    <div class="remark-list" v-if="item.remarks && item.remarks.length > 0">
                        <div class="remark" v-for="(remark,remarkIndex) in item.remarks" :key="remarkIndex">
                            <span class="remark-name">{{remark.nickname}}</span>
                            <span class="remark-time">{{remark.t_submit}}</span>
                            <van-rate class="top-10" color="#ffd21e" :count="6" readonly v-model="remark.rank" />
                            <div class="remark-content">{{remark.content}}</div>
                            <comment-pic :urls="remark.imgs"></comment-pic>
                            <!-- 点评声音 -->
                            <div v-if="remark.audio" @click="playAudio(remark.audio.audioUrl,item.pt_id)" class="audio-box">
                                <img class="audio-img" src="@/assets/icon/audio.png" />
                                <span class="audio-duration">{{remark.audio.duration}}″</span>
                            </div>
                            <!-- 点评印章 -->
                            <img class="remark-img" v-if="remark.rank == 6" src="@/assets/icon/A+.png" />
                            <img class="remark-img" v-if="remark.rank == 5" src="@/assets/icon/A.png" />
                            <img class="remark-img" v-if="remark.rank == 4" src="@/assets/icon/B.png" />
                            <img class="remark-img" v-if="remark.rank == 3" src="@/assets/icon/C.png" />
                            <img class="remark-img" v-if="remark.rank == 2" src="@/assets/icon/D.png" />
                            <img class="remark-img" v-if="remark.rank == 1" src="@/assets/icon/need_change.png" />
                        </div>
                    </div>
                    <!-- 评论详情 -->
                    <div class="comment-list" v-if="item.comments.length > 0">
                        <div v-for="(comment,commentIndex) in item.comments" :key="commentIndex">
                            <div class="flex-column" v-if="commentIndex < 6">
                                <div class="flex-row">
                                    <span class="comment-item-text">{{comment.nickname}} {{ comment.reply_to.length > 0 ? '回复'+ comment.reply_to : ''}}：</span>
                                    <div class="comment-item-text" style="flex:1;">{{comment.content}}</div>
                                </div>
                                <div class="audio-box" v-if="comment.audio" @click="playAudio(comment.audio.audioUrl)">
                                    <img class="audio-img" src="@/assets/icon/audio.png" />
                                    <span class="audio-duration">{{comment.audio.duration}}″</span>
                                </div>
                            </div>
                        </div>
                        <span @click="showDialog" v-if="item.comments.length > 6" class="look-all-comment">点击查看所有评论</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 空布局 -->
        <div class="empty-box" v-if="records.length == 0">
            <span class="empty-text">暂无内容</span>
        </div>

        <!-- 日期选择器 -->
        <van-popup :close-on-click-overlay="false" v-model="showDatePicker" position="bottom">
            <van-datetime-picker type="date" v-model="pickerDate" @cancel="cancel" @confirm="setCurrentDate"></van-datetime-picker>
        </van-popup>
        <!-- 前往小程序 -->
        <mini-dialog :cid="checkin.cid" message="该功能不支持在H5中使用，请前往小程序使用该功能" @close="showMini = false" :showMini="showMini"></mini-dialog>
    </div>
</template>
<script>
import { formatDate, getToken, getUTCDateInSeconds, getDaysLater } from '@/utils/common'
import http from "@/utils/http";
import Avatar from '@/components/Avatar.vue';
import CommentPic from '@/components/CommentPic.vue';
import OpenDocument from '@/components/OpenDocument.vue';
import VideoBox from '@/components/VideoBox.vue';
import ArticleBox from '@/components/ArticleBox.vue';
import MiniDialog from '@/components/MiniDialog.vue';


export default {
  components: { Avatar,CommentPic,OpenDocument,VideoBox,ArticleBox,MiniDialog},
   name: 'RecordList',
   props:{
       checkin:{
           type: Object,
           default: null
       },
       hasUserInfo:{
           type: Boolean,
           default:false
       }
   },
   data:() => {
       return {
           curTag:'all', //当前的类型 all today date
           records:[],
           choosed_date:'选择日期',
           showDatePicker: false, //是否显示日期选择器
           currentDate:'', //当前日期
           pickerDate: '', // 日期选择起的日期
           page: 1, // 分页
           count: 20,
           view_type: 0, // 全部 普通 任务
           max_id: '',

           pt_id:'',
           showAudioPlayer: false,
           audioSrc: '',

           showMini: false, //是否显示小程序弹窗
       }
   },
   computed: {
        currentDateText() {
            if(this.currentDate == '') {
                return ''
            }else {
                return formatDate(this.currentDate,'yyyy-MM-dd')
            }
        }
   },
   created() {
       // 获取签到记录列表
        this.getRecordsList()
   },
   mounted(){
        // 屏幕滑动到底部的监听
        window.onscroll = () => {
            // 变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            // 变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
            // 变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
            // 滚动条到底部的条件
            if (scrollTop + windowHeight > scrollHeight - 60) {
                if(this.records.length < this.page * this.count) {
                    return 
                }
                this.page++ 
                this.getRecordsList()
            }
        }
   },
   methods: {
       changeType(type) {
           if(type == 'date') {
               if(this.currentDate == '') {
                   this.pickerDate = new Date()
               }else {
                   this.pickerDate = this.currentDate
               }
               this.showDatePicker = true
           }else {
               if(this.curTag == type){
                   return
               }
               this.curTag = type
               if(this.curTag == 'today') {
                   this.start = getUTCDateInSeconds(formatDate(getDaysLater(0), 'yyyy-MM-dd'))
                   this.end = getUTCDateInSeconds(formatDate(getDaysLater(1),'yyyy-MM-dd')) - 1
               }else {
                   this.start = ''
                   this.end = ''
               }
               this.page = 1;
               this.getRecordsList()
           }
       },
       setCurrentDate(date) {
           this.showDatePicker = false
           this.pickerDate = date
           this.currentDate = date
           this.curTag = 'date'
           this.start = getUTCDateInSeconds(formatDate(this.currentDate,'yyyy-MM-dd'))
           this.end = getUTCDateInSeconds(formatDate(this.currentDate,'yyyy-MM-dd')) + 24 * 3600 -1
           this.page = 1;
           this.getRecordsList()
       },
       cancel() {
           this.showDatePicker = false
       },
       playAudio(audio,pt_id) {
           if(audio) {
               this.pt_id = pt_id
               this.showAudioPlayer = true
               this.audioSrc = audio
           }
       },
        // 获取签到动态
       getRecordsList() {
            let params = {
               cid: this.checkin.cid,
               sort_type: 0,
               page:this.page,
               count: this.count,
               start: this.start || 0,
               end: this.end || 0,
               access_token: getToken(),
               view_type: this.view_type,
               max_id: this.max_id
            }
            if(this.checkin.permiss == 1 && this.checkin.is_owner == 0 && this.checkin.is_admin == 0) {
                params.unionid = this.checkin.unionid
            }

            http.get('/xcx/checkin/v3/pic_text',params).then(res=>{
                let records = res.data
                for (let i = 0;i < records.length; i++){
                    let record = records[i]
                    record.date = formatDate(new Date(record.date * 1000), 'yyyy-MM-dd HH:mm:ss')
                    if (typeof record.pic == 'string') {
                        record.pic = record.pic ? [record.pic] : []
                    }
                    if (record.fix && record.fix.date) {
                        record.fix.date = formatDate(new Date(record.fix.date * 1000), 'yyyy-MM-dd HH:mm:ss')
                    }
                    if (!record.head_url) {
                        record.head_url = '@/assets/icon/default_avatar.png'
                    }
                    if (record.remarks && record.remarks.length > 0) {
                        let remarks = record.remarks
                        for (let j = 0; j < remarks.length; j++) {
                            remarks[j].t_submit = formatDate(new Date(remarks[j].t_submit * 1000), 'yyyy-MM-dd HH:mm:ss')
                        }
                    }
                }

                this.max_id = res.max_id || ''
                this.records = this.page == 1 ? records : this.records.concat(records)
                this.$forceUpdate();
            })
       },
        // 提示
       showDialog() {
           this.showMini = true
       }
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}
.list {
    display: flex;
    flex-direction: column;
    padding: rem(20) rem(20);
    box-sizing: border-box;
}
.item {
    display: flex;
    flex-direction: row;
    margin-bottom: rem(20);
}
.text-30-black {
    font-size: rem(30);
    color: #000;
}
.text-28-99 {
    font-size: rem(28);
    color: #999;
}
.text-30-blue {
    font-size: rem(30);
    color: #12b7f5;
}
.icon-30 {
    width: rem(30);
    height: rem(30);
}
.choose-btn {
    padding: 0 rem(16);
    height: rem(40);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: rem(20);
    margin-left: rem(10);
    border: 1px solid #e5e5e5;
    color: #999;
    font-size: 24;
}
.active {
    color: #12b7f5;
    border: 1px solid #12b7f5;
}
.left-10 {
    margin-left: rem(10);
}
.right-10 {
    margin-right: rem(10);
}
.stu-no {
    border-radius: rem(8);
    border: 1px solid #999;
    color: #262626;
    font-size: rem(26);
    padding: rem(2) rem(6);
    margin-right: rem(10);
}
.top-img {
    width: rem(64);
    height: rem(28);
    margin-left: rem(10);
}
.top-10 {
    margin-top: rem(10);
}
.top-20 {
    margin-top: rem(20);
}
.text-22-99 {
    font-size: rem(22);
    color: #999;
}
.icon-buqian {
    width: rem(52);
    height: rem(26);
    margin-left: rem(10);
}
.icon-edit {
    width: rem(30);
    height: rem(30);
    margin-right: rem(10);
}
.icon-40 {
    width: rem(40);
    height: rem(40);
}
.like-img {
    width: rem(40);
    height: rem(40);
}
.like-text {
    font-size: rem(28);
    color: #999;
    margin-left: rem(5);
}
.remark-list {
    display: flex;
    flex-direction: column;
    background-color: #fff9ed;
    margin-top: rem(20);
}
.remark {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: rem(10) rem(30);
}
.remark-name {
    font-size: rem(28);
    color: #262626;
}
.remark-time {
    margin-top: rem(10);
    font-size: rem(20);
    color: #999;
}
.remark-content {
    margin-top: rem(10);
    font-size: rem(26);
    color: #262626;
    margin-bottom: rem(20);
}

.audio-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: rem(130);
    margin-top: rem(10);
    margin-right: rem(15);
    padding: rem(10) rem(8);
    border-radius: rem(8);
    background-color: #12b7f5;
}
.audio-img {
    width: rem(21);
    height: rem(28);
    margin-right: rem(10);
    margin-left: rem(10);
}
.audio-duration {
    font-size: rem(30);
    color: #fff;
}
.remark-img {
    position: absolute;
    right: rem(20);
    top: rem(20);
    width: rem(100);
    height: rem(100);
}
.comment-list {
    padding: rem(10);
    background-color: #f2f2f7;
    margin-top: rem(10);

}
.comment-item {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.comment-item-text {
    margin-top: rem(10);
    font-size: rem(26);
    color: #262626;
}
.look-all-comment {
    font-size: rem(28);
    color: #12b7f5;
    padding-bottom: rem(10);
}
.checkin-text {
    margin-bottom: rem(10);
    color: #262626;
    font-size: rem(30);
    white-space: normal;
    word-break: break-all;
}
.audio-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
}
.address-box {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.address-icon {
    width: rem(48);
    height: rem(48);
    margin-right: rem(10);
}
.address-text {
    flex: 1;
    font-size: rem(26);
    color: #262626;
}
.step-box {
    display: inline-block;
    height: rem(60);  
    background-color: #666;
    height: rem(60);
    border-radius: rem(30);
}
.step-box-content {
    padding: 0 rem(20);
    height: rem(60);
    border-radius: rem(30);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.step-text {
    font-size: rem(26);
    color: #fff;
}
.step-icon {
    width: rem(26);
    height: rem(26);
}

.empty-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: rem(20);
    font-size: rem(28);
    color: #999;
}
.text-28-33 {
    font-size: rem(28);
    color: #333;
    line-height: rem(88);
}
.checkin-time {
    font-size: rem(22);
    color: #999;
}
.audio {
    margin-top: rem(10);
    margin-bottom: rem(10);
}

</style>


// WEBPACK FOOTER //
// src/components/RecordList.vue